import React from "react"

function Arrow(props) {
  return (
    <svg width={27} height={27} {...props}>
      <path
        d="M13.524 6c.238 0 .476.092.667.276l12.523 12.112a.924.924 0 010 1.336 1 1 0 01-1.38 0L13.475 8.257 1.666 19.724a1 1 0 01-1.38 0 .923.923 0 010-1.336L12.81 6.276A1.07 1.07 0 0113.524 6z"
        fill={ `${ props.color }` || '#4B3866'}
      />
    </svg>
  )
}

export default Arrow
